"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _reactRedux = require("react-redux");

var _LogoutDialog = require("../LogoutDialog");

var _LogoutDialog2 = _interopRequireDefault(_LogoutDialog);

var _common = require("config/common.js");

var _common2 = _interopRequireDefault(_common);

var _commons = require("egov-ui-framework/ui-utils/commons");

var _components = require("components");

var _store = require("ui-redux/store");

var _store2 = _interopRequireDefault(_store);

var _download = require("egov-ui-kit/assets/images/download.png");

var _download2 = _interopRequireDefault(_download);

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _commons2 = require("egov-ui-kit/utils/commons");

var _commonMenuItems = require("../NavigationDrawer/commonMenuItems");

var _ClickAwayListener = require("@material-ui/core/ClickAwayListener");

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _actions = require("egov-ui-kit/redux/app/actions");

var _api = require("egov-ui-kit/utils/api");

var _formActionUtils = require("egov-ui-kit/utils/PTCommon/FormWizardUtils/formActionUtils");

var _actions2 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserSettings = function (_Component) {
  (0, _inherits3.default)(UserSettings, _Component);

  function UserSettings(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, UserSettings);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserSettings.__proto__ || Object.getPrototypeOf(UserSettings)).call(this, props));

    _this.style = {
      errorMessage: {
        color: "red",
        position: "relative",
        bottom: "26px",
        left: "120px",
        fontSize: "11px"
      },
      baseStyle: {
        background: "#ffffff",
        height: "65px",
        marginRight: "30px",
        width: "98px",
        marginBottom: "24px",
        display: "none"
      },
      label: {
        color: "#5F5C57",
        fontSize: "12px",
        paddingRight: "0px"
      },
      arrowIconStyle: {
        marginTop: "7px",
        marginRight: "13px"
      },
      iconStyle: {
        marginRight: "30px"
      },
      listStyle: {
        display: "block"
      },
      listInnerDivStyle: {
        padding: "10px",
        display: "flex",
        alignItems: "center"
      },
      baseTenantStyle: {
        background: "#ffffff",
        height: "65px",
        marginRight: "30px",
        width: "145px",
        marginBottom: "24px"
      }
    };

    _this.onChange = function (event, index, value) {
      _this.setState((0, _extends3.default)({}, _this.state, { languageSelected: value }));
      _this.props.fetchLocalizationLabel(value);
    };

    _this.handleTenantChange = function () {
      var tenantSelected = _this.state.tempTenantSelected;
      _this.setState((0, _extends3.default)({}, _this.state, { tenantSelected: tenantSelected }));
      (0, _localStorageUtils.setTenantId)(tenantSelected);
      _this.props.setRoute("/");
    };

    _this.onTenantChange = function (event, index, value) {
      if (location.pathname.includes("/inbox")) {
        _this.setState((0, _extends3.default)({}, _this.state, { tenantSelected: value }));
        (0, _localStorageUtils.setTenantId)(value);
        _this.props.setRoute("/");
      } else {
        _this.setState((0, _extends3.default)({}, _this.state, { open: true, tempTenantSelected: value }));
      }
    };

    _this.handleClose = function () {
      _this.setState((0, _extends3.default)({}, _this.state, { open: false }));
    };

    _this.onLanguageChange = function (event, index, value) {
      //const {setRote} = this.props;
      _this.setState({ languageSelected: value });
      var tenantId = (0, _localStorageUtils.getTenantId)();

      if (process.env.REACT_APP_NAME === "Citizen") {
        var tenantInfo = (0, _commons2.getQueryArg)(window.location.href, "tenantId");
        var userInfo = JSON.parse((0, _localStorageUtils.getUserInfo)());
        tenantId = userInfo && userInfo.permanentCity;
        tenantId = tenantInfo ? tenantInfo : tenantId;
      }
      var resetList = [];
      var newList = JSON.stringify(resetList);
      (0, _localStorageUtils.setStoredModulesList)(newList);
      var locale = (0, _localStorageUtils.getLocale)();
      var resultArray = [];
      (0, _actions.setLocalizationLabels)(locale, resultArray);
      _this.props.fetchLocalizationLabel(value, tenantId, tenantId);
    };

    _this.handleClose = function (event) {
      // if (this.anchorEl.contains(event.target)) {
      //   return;
      // }
      _this.setState({ displayAccInfo: false });
    };

    _this.componentDidMount = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var userId, employeeType, requestData, modulesAllData, payloadModules;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(process.env.REACT_APP_NAME == "Employee")) {
                _context.next = 12;
                break;
              }

              userId = JSON.parse(localStorage.getItem("user-info")).id;
              employeeType = JSON.parse(localStorage.getItem("user-info")).employeeType;
              requestData = {
                userId: userId.toString(),
                employeeType: employeeType
              };
              modulesAllData = [];
              payloadModules = null;
              _context.next = 8;
              return (0, _api.httpRequest)("pwc-db-services/getMappedModules", "_search", [], requestData);

            case 8:
              payloadModules = _context.sent;


              payloadModules && payloadModules.data && payloadModules.data.map(function (w) {
                modulesAllData.push({
                  name: w.role,
                  code: w.id,
                  label: w.role,
                  value: w.id
                });
              });
              localStorage.setItem("moduleData", JSON.stringify(modulesAllData));
              _this.setState({ moduleData: modulesAllData });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.handleChangeForDepartment = function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e, value, selectedValue) {
        var fetchActionMenu, url, userInfo, roles, userId, officeId, departmentId, role, id, keysToRemove, roleCodes, employeeType, requestData, departmentAllData, payloadDepartment;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _store2.default.dispatch((0, _actions2.prepareFinalObject)("roleError", false));
                fetchActionMenu = _this.props.fetchActionMenu;
                url = "pwc-db-services/getMappedDepartments";
                userInfo = JSON.parse((0, _localStorageUtils.getUserInfo)());
                roles = (0, _get2.default)(userInfo, "roles");
                userId = (0, _get2.default)(userInfo, "id");
                officeId = JSON.parse((0, _localStorageUtils.getOfficeID)()) || "7867";
                departmentId = JSON.parse((0, _localStorageUtils.getDepartmentId)()) || "999901";
                role = JSON.parse((0, _localStorageUtils.getRole)()) || "333";
                id = process.env.REACT_APP_NAME === "Citizen" ? JSON.parse(localStorage.getItem("Citizen.user-info")).id : JSON.parse(localStorage.getItem("Employee.user-info")).id;

                // set localstorage item value to "" before on change

                keysToRemove = ["moduleId", "departmentData", "userDepartmentId", "officeIdData", "roleId", "officeId", "roleData"];

                keysToRemove.forEach(function (k) {
                  return localStorage.setItem(k, "");
                });
                _this.setState({ roleData: [], roleId: "", officeIdData: [], officeId: "", departmentData: [], departmentId: "", moduleId: selectedValue });

                roleCodes = roles ? roles.map(function (role) {
                  if (role.tenantId == (0, _localStorageUtils.getTenantId)()) {
                    return role.code;
                  }
                }) : [];
                employeeType = JSON.parse(localStorage.getItem("user-info")).employeeType;
                requestData = {
                  userId: userId.toString(),
                  moduleId: selectedValue.toString(),
                  employeeType: employeeType
                };
                departmentAllData = [], payloadDepartment = null;
                //   get department from module ID and stored in loacalstroge and state

                _context2.next = 19;
                return (0, _api.httpRequest)(url, "_search", [], requestData);

              case 19:
                payloadDepartment = _context2.sent;

                payloadDepartment && payloadDepartment.data && payloadDepartment.data.map(function (w) {
                  departmentAllData.push({
                    name: w.department,
                    code: w.id,
                    label: w.department,
                    value: w.id
                  });
                });

                localStorage.setItem("moduleId", selectedValue);
                localStorage.setItem("departmentData", JSON.stringify(departmentAllData));
                _this.setState({ departmentData: departmentAllData });
                // call action menu again for updated list
                _context2.next = 26;
                return fetchActionMenu({
                  employeeType: employeeType,
                  roleCodes: roleCodes,
                  tenantId: _common2.default.tenantId,
                  actionMaster: "actions-test",
                  enabled: true,
                  officeId: officeId.toString(),
                  departmentId: departmentId.toString(),
                  roleId: role.toString(),
                  moduleId: selectedValue.toString(),
                  userId: id
                }, {
                  ts: new Date().getTime()
                });

              case 26:
                _this.setState({ roleError: false });

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleChangeForOffice = function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(e, value, selectedValue) {
        var fetchActionMenu, moduleId, userInfo, roles, userId, officeId, departmentId, role, id, keysToRemove, roleCodes, employeeType, requestData, officeAllData, payloadOffices, departmentData, departmentname;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _store2.default.dispatch((0, _actions2.prepareFinalObject)("roleError", false));
                fetchActionMenu = _this.props.fetchActionMenu;
                moduleId = _this.state.moduleId;
                userInfo = JSON.parse((0, _localStorageUtils.getUserInfo)());
                roles = (0, _get2.default)(userInfo, "roles");
                userId = (0, _get2.default)(userInfo, "id");
                officeId = JSON.parse((0, _localStorageUtils.getOfficeID)()) || "7867";
                departmentId = JSON.parse((0, _localStorageUtils.getDepartmentId)()) || "999901";
                role = JSON.parse((0, _localStorageUtils.getRole)()) || "333";
                id = process.env.REACT_APP_NAME === "Citizen" ? JSON.parse(localStorage.getItem("Citizen.user-info")).id : JSON.parse(localStorage.getItem("Employee.user-info")).id;
                keysToRemove = ["roleData", "roleId", "officeIdData", "officeId"];

                keysToRemove.forEach(function (k) {
                  return localStorage.setItem(k, "");
                });
                _this.setState((0, _defineProperty3.default)({ roleData: [], roleId: "", officeIdData: [], officeId: "", departmentId: "" }, "departmentId", selectedValue));

                roleCodes = roles ? roles.map(function (role) {
                  if (role.tenantId == (0, _localStorageUtils.getTenantId)()) {
                    return role.code;
                  }
                }) : [];
                employeeType = JSON.parse(localStorage.getItem("user-info")).employeeType;
                requestData = {
                  userId: userId.toString(),
                  moduleId: moduleId.toString(),
                  departmentId: selectedValue.toString(),
                  employeeType: employeeType
                };
                officeAllData = [];
                payloadOffices = null;
                _context3.next = 20;
                return (0, _api.httpRequest)("pwc-db-services/getMappedOffices", "_search", [], requestData);

              case 20:
                payloadOffices = _context3.sent;


                payloadOffices && payloadOffices.data && payloadOffices.data.map(function (w) {
                  officeAllData.push({
                    name: w.office_name,
                    code: w.id,
                    label: w.office_name,
                    value: w.id
                  });
                });
                localStorage.setItem("userDepartmentId", selectedValue);
                departmentData = _this.state.departmentData;
                departmentname = departmentData.filter(function (item) {
                  return item.value == selectedValue;
                });

                localStorage.setItem("departmentname", departmentname[0].label);
                localStorage.setItem("officeIdData", JSON.stringify(officeAllData));
                _this.setState({ officeIdData: officeAllData });
                _context3.next = 30;
                return fetchActionMenu({
                  employeeType: employeeType,
                  roleCodes: roleCodes,
                  tenantId: _common2.default.tenantId,
                  actionMaster: "actions-test",
                  enabled: true,
                  officeId: officeId.toString(),
                  departmentId: selectedValue.toString(),
                  roleId: role.toString(),
                  moduleId: moduleId.toString(),
                  userId: id
                }, {
                  ts: new Date().getTime()
                });

              case 30:
                _this.setState({ roleError: false });

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.handleChangeForRole = function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(e, value, selectedValue) {
        var fetchActionMenu, _this$state, moduleId, departmentId, userInfo, userId, roles, officeId, role, id, officeAllData, selectdOffice, keysToRemove, roleCodes, employeeType, requestData, rolesAllData, mappedRole, payloadRoles, employeeData, userData;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _store2.default.dispatch((0, _actions2.prepareFinalObject)("roleError", false));
                fetchActionMenu = _this.props.fetchActionMenu;
                _this$state = _this.state, moduleId = _this$state.moduleId, departmentId = _this$state.departmentId;
                userInfo = JSON.parse((0, _localStorageUtils.getUserInfo)());
                userId = (0, _get2.default)(userInfo, "id");
                roles = (0, _get2.default)(userInfo, "roles");
                officeId = (0, _localStorageUtils.getOfficeID)() || "7867";
                // const departmentId = JSON.parse(getDepartmentId()) || "999901";

                role = JSON.parse((0, _localStorageUtils.getRole)()) || "333";
                // const moduleId = JSON.parse(getModule()) || "";

                id = process.env.REACT_APP_NAME === "Citizen" ? JSON.parse(localStorage.getItem("Citizen.user-info")).id : JSON.parse(localStorage.getItem("Employee.user-info")).id;
                officeAllData = JSON.parse(localStorage.getItem("officeIdData"));
                selectdOffice = officeAllData.filter(function (item) {
                  return item.code == selectedValue;
                });
                // set localstorage item value to "" before on change

                keysToRemove = ["roleData", "roleId"];

                keysToRemove.forEach(function (k) {
                  return localStorage.setItem(k, "");
                });
                _this.setState((0, _defineProperty3.default)({ roleData: [], roleId: "", officeId: "" }, "officeId", selectedValue));

                roleCodes = roles ? roles.map(function (role) {
                  if (role.tenantId == (0, _localStorageUtils.getTenantId)()) {
                    return role.code;
                  }
                }) : [];
                employeeType = JSON.parse(localStorage.getItem("user-info")).employeeType;
                requestData = {
                  userId: userId.toString(),
                  moduleId: moduleId.toString(),
                  departmentId: departmentId.toString(),
                  officeId: selectedValue.toString(),
                  employeeType: employeeType
                };
                rolesAllData = [];
                mappedRole = [];
                payloadRoles = null;
                _context4.next = 22;
                return (0, _api.httpRequest)("pwc-db-services/getMappedRoles", "_search", [], requestData);

              case 22:
                payloadRoles = _context4.sent;


                payloadRoles && payloadRoles.data && payloadRoles.data.map(function (w) {
                  rolesAllData.push({
                    name: w.role,
                    code: w.id,
                    label: w.role,
                    value: w.id
                  });
                });
                payloadRoles && payloadRoles.data && payloadRoles.data.map(function (w) {
                  mappedRole.push({
                    name: w.role,
                    code: w.code,
                    tenantId: "km.kolkata"
                  });
                });
                employeeData = JSON.parse(localStorage.getItem("Employee.user-info"));
                userData = JSON.parse(localStorage.getItem("user-info"));
                // employeeData.roles = mappedRole;
                // userData.roles = mappedRole;

                localStorage.setItem("Employee.user-info", JSON.stringify(employeeData));
                localStorage.setItem("user-info", JSON.stringify(userData));
                localStorage.setItem("officeId", selectedValue);
                localStorage.setItem("roleData", JSON.stringify(rolesAllData));
                localStorage.setItem("officeName", selectdOffice[0].name);
                _this.setState({ roleData: rolesAllData });

                _context4.next = 35;
                return fetchActionMenu({
                  employeeType: employeeType,
                  roleCodes: roleCodes,
                  tenantId: _common2.default.tenantId,
                  actionMaster: "actions-test",
                  enabled: true,
                  officeId: selectedValue.toString(),
                  departmentId: departmentId.toString(),
                  roleId: role.toString(),
                  moduleId: moduleId.toString(),
                  userId: id
                }, {
                  ts: new Date().getTime()
                });

              case 35:
                _this.setState({ roleError: false });

              case 36:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }));

      return function (_x7, _x8, _x9) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.handleChangeForAction = function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(e, value, selectedValue) {
        var fetchActionMenu, _this$state2, moduleId, departmentId, officeId, userInfo, userId, roles, role, roleData, selectedRoleData, id, roleCodes, employeeType, roleError;

        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _store2.default.dispatch((0, _actions2.prepareFinalObject)("roleError", false));
                fetchActionMenu = _this.props.fetchActionMenu;
                _this$state2 = _this.state, moduleId = _this$state2.moduleId, departmentId = _this$state2.departmentId, officeId = _this$state2.officeId;
                userInfo = JSON.parse((0, _localStorageUtils.getUserInfo)());
                userId = (0, _get2.default)(userInfo, "id");
                roles = (0, _get2.default)(userInfo, "roles");
                // const officeId = getOfficeID() || "7867";
                // const departmentId = getDepartmentId() || "999901";

                role = (0, _localStorageUtils.getRole)() || "333";
                // const moduleId = JSON.parse(getModule()) || "";

                localStorage.setItem("roleId", selectedValue);
                _this.setState({ roleId: selectedValue });
                roleData = _this.state.roleData;
                selectedRoleData = roleData.filter(function (item) {
                  return item.value == selectedValue;
                });

                localStorage.setItem("rolename", selectedRoleData[0].label);

                id = process.env.REACT_APP_NAME === "Citizen" ? JSON.parse(localStorage.getItem("Citizen.user-info")).id : JSON.parse(localStorage.getItem("Employee.user-info")).id;
                roleCodes = roles ? roles.map(function (role) {
                  if (role.tenantId == (0, _localStorageUtils.getTenantId)()) {
                    return role.code;
                  }
                }) : [];
                employeeType = JSON.parse(localStorage.getItem("user-info")).employeeType;
                _context5.next = 17;
                return fetchActionMenu({
                  roleCodes: roleCodes,
                  tenantId: _common2.default.tenantId,
                  actionMaster: "actions-test",
                  enabled: true,
                  officeId: officeId.toString(),
                  departmentId: departmentId.toString(),
                  roleId: selectedValue.toString(),
                  moduleId: moduleId.toString(),
                  userId: id,
                  employeeType: employeeType
                }, {
                  ts: new Date().getTime()
                });

              case 17:
                roleError = (0, _get2.default)(_store2.default.getState().screenConfiguration.preparedFinalObject, "roleError");
                // VIEW: Redirect user to index page if there is no action menu.

                if (roleError) _this.setState({ roleError: roleError });
                (0, _formActionUtils.routeTo)("/");

              case 20:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this2);
      }));

      return function (_x10, _x11, _x12) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.state = {
      languageSelected: (0, _localStorageUtils.getLocale)(),
      displayAccInfo: false,
      tenantSelected: (0, _localStorageUtils.getTenantId)(),
      tempTenantSelected: (0, _localStorageUtils.getTenantId)(),
      open: false,
      roleError: false,
      officeIdData: localStorage.getItem("officeIdData") ? JSON.parse(localStorage.getItem("officeIdData")) : [],
      officeId: localStorage.getItem("officeId") || "",
      departmentData: localStorage.getItem("departmentData") ? JSON.parse(localStorage.getItem("departmentData")) : [],
      departmentId: localStorage.getItem("userDepartmentId") || "",
      roleData: localStorage.getItem("roleData") ? JSON.parse(localStorage.getItem("roleData")) : [],
      roleId: localStorage.getItem("roleId") || "",
      moduleData: localStorage.getItem("moduleData") ? JSON.parse(localStorage.getItem("moduleData")) : [],
      moduleId: localStorage.getItem("moduleId") || "",
      name: JSON.parse(localStorage.getItem("user-info")).name,
      userRole: JSON.parse(localStorage.getItem("user-info")).roles[0].name
    };
    return _this;
  }

  (0, _createClass3.default)(UserSettings, [{
    key: "toggleAccInfo",


    // onUserChange = (event, index, value) => {
    //   const { setRoute } = this.props;

    //   setRoute(value);
    // }

    value: function toggleAccInfo() {
      this.setState({
        displayAccInfo: !this.state.displayAccInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          languageSelected = _state.languageSelected,
          displayAccInfo = _state.displayAccInfo,
          officeId = _state.officeId,
          departmentId = _state.departmentId,
          roleId = _state.roleId,
          moduleId = _state.moduleId,
          name = _state.name,
          userRole = _state.userRole,
          moduleData = _state.moduleData,
          tenantSelected = _state.tenantSelected,
          open = _state.open,
          officeIdData = _state.officeIdData,
          departmentData = _state.departmentData,
          roleData = _state.roleData;
      var style = this.style;
      var _props = this.props,
          onIconClick = _props.onIconClick,
          userInfo = _props.userInfo,
          handleItemClick = _props.handleItemClick,
          hasLocalisation = _props.hasLocalisation,
          languages = _props.languages,
          isUserSetting = _props.isUserSetting;

      /**
       * Get All tenant id's from (user info -> roles) to populate dropdown
       */

      var tenantIdsList = (0, _get2.default)(userInfo, "roles", []).map(function (role) {
        return role.tenantId;
      });
      tenantIdsList = [].concat((0, _toConsumableArray3.default)(new Set(tenantIdsList)));
      tenantIdsList = tenantIdsList.map(function (tenantId) {
        return { value: tenantId, label: (0, _commons.getLocaleLabels)(tenantId, "TENANT_TENANTS_" + (0, _commons.getTransformedLocale)(tenantId)) };
      });

      return _react2.default.createElement(
        "div",
        { className: "userSettingsContainer" },
        isUserSetting && _react2.default.createElement(_LogoutDialog2.default, {
          logoutPopupOpen: open,
          closeLogoutDialog: this.handleClose,
          logout: this.handleTenantChange,
          oktext: "CORE_CHANGE_TENANT_OK",
          canceltext: "CORE_CHANGE_TENANT_CANCEL",
          title: "CORE_CHANGE_TENANT",
          body: "CORE_CHANGE_TENANT_DESCRIPTION"
        }),
        process.env.REACT_APP_NAME === "Employee" && isUserSetting && _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(_components.DropDown, {
              onChange: this.onTenantChange,
              listStyle: style.listStyle,
              style: style.baseTenantStyle,
              labelStyle: style.label,
              dropDownData: tenantIdsList,
              value: tenantSelected,
              underlineStyle: { borderBottom: "none" }
            }),
            _react2.default.createElement(_components.DropDown, {
              listStyle: style.listStyle,
              style: style.baseTenantStyle,
              className: "header_dropdown",
              labelStyle: style.label,
              dropDownData: moduleData,
              hintText: "Select Module",
              onChange: function onChange(e, value, selectedValue) {
                _this3.handleChangeForDepartment(e, value, selectedValue);
              },
              value: moduleId,
              underlineStyle: { borderBottom: "none" }
            }),
            _react2.default.createElement(_components.DropDown, {
              listStyle: style.listStyle,
              style: style.baseTenantStyle,
              className: "header_dropdown",
              labelStyle: style.label,
              dropDownData: departmentData,
              hintText: "Select Department",
              onChange: function onChange(e, value, selectedValue) {
                // localStorage.setItem("departmentId", selectedValue);
                // this.setState({ departmentId: selectedValue });
                // window.location.reload();
                // this.setDepartment()
                _this3.handleChangeForOffice(e, value, selectedValue);
              },
              value: departmentId,
              underlineStyle: { borderBottom: "none" }
            }),
            _react2.default.createElement(_components.DropDown, {
              listStyle: style.listStyle,
              style: style.baseTenantStyle,
              className: "header_dropdown",
              labelStyle: style.label,
              dropDownData: officeIdData,
              hintText: "Select Office",
              onChange: function onChange(e, value, selectedValue) {
                // localStorage.setItem("officeId", selectedValue);
                // this.setState({ officeId: selectedValue });
                // window.location.reload();
                _this3.handleChangeForRole(e, value, selectedValue);
              },
              value: officeId,
              underlineStyle: { borderBottom: "none" }
            }),
            _react2.default.createElement(_components.DropDown, {
              listStyle: style.listStyle,
              style: style.baseTenantStyle,
              className: "header_dropdown",
              labelStyle: style.label,
              dropDownData: roleData,
              hintText: "Select Role",
              onChange: function onChange(e, value, selectedValue) {
                // localStorage.setItem("role", selectedValue);
                //this.setState({ roleId: selectedValue });
                //window.location.reload();
                _this3.handleChangeForAction(e, value, selectedValue);
              },
              value: roleId,
              underlineStyle: { borderBottom: "none" }
            })
          ),
          this.props.roleError && _react2.default.createElement(
            "span",
            { style: style.errorMessage },
            "No data exists pertaining to Module - Department - Office - Role"
          )
        ),
        hasLocalisation && _react2.default.createElement(_components.DropDown, {
          onChange: this.onLanguageChange,
          listStyle: style.listStyle,
          style: style.baseStyle,
          labelStyle: style.label,
          dropDownData: languages,
          value: languageSelected,
          underlineStyle: { borderBottom: "none" }
        }),
        _react2.default.createElement(
          _ClickAwayListener2.default,
          { onClickAway: this.handleClose },
          isUserSetting && _react2.default.createElement(
            "div",
            {
              onClick: function onClick() {
                _this3.toggleAccInfo();
              },
              className: "userSettingsInnerContainer",
              style: { marginBottom: "14px" }
            },
            _react2.default.createElement(_components.Image, { width: "33px", circular: true, source: userInfo.photo || _download2.default }),
            _react2.default.createElement(_components.Icon, { action: "navigation", name: "arrow-drop-down", color: "#767676", style: style.arrowIconStyle }),
            userRole != "Citizen" && _react2.default.createElement(
              "span",
              { style: { position: "absolute", bottom: "0", right: "3%" } },
              name.toUpperCase()
            ),
            userRole == "Citizen" && _react2.default.createElement(
              "span",
              { style: { position: "absolute", bottom: "0", right: "3%" } },
              name.toUpperCase()
            ),
            _react2.default.createElement(
              "div",
              { className: "user-acc-info" },
              displayAccInfo ? _react2.default.createElement(_components.List, {
                opem: true,
                onItemClick: function onItemClick(item) {
                  handleItemClick(item, false);
                },
                innerDivStyle: style.listInnerDivStyle,
                className: "drawer-list-style",
                items: _commonMenuItems.CommonMenuItems,
                listContainerStyle: { background: "#ffffff" },
                listItemStyle: { borderBottom: "1px solid #e0e0e0" }
              }) : ""
            )
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var officeIdvalue = parseInt(localStorage.getItem("officeId")) || "";
      var rolevalue = parseInt(localStorage.getItem("roleId")) || "";
      var departmentIdvalue = parseInt(localStorage.getItem("userDepartmentId")) || "";
      var moduleIdvalue = parseInt(localStorage.getItem("moduleId")) || "";
      return { officeId: officeIdvalue, departmentId: departmentIdvalue, roleId: rolevalue, moduleId: moduleIdvalue };
    }

    // on change handler for module


    //   on change handler for action (role change)

  }]);
  return UserSettings;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref6) {
  var app = _ref6.app,
      common = _ref6.common,
      preparedFinalObject = _ref6.screenConfiguration.preparedFinalObject;
  var locale = app.locale;
  var stateInfoById = common.stateInfoById;

  var languages = (0, _get2.default)(stateInfoById, "0.languages", []);
  var roleError = preparedFinalObject.roleError;

  return { languages: languages, locale: locale, roleError: roleError };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fetchActionMenu: function fetchActionMenu(role, ts) {
      return dispatch((0, _actions.fetchActionItems)(role, ts));
    },
    setRoute: function setRoute(route) {
      return dispatch((0, _actions.setRoute)(route));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserSettings);


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/common/Header/components/UserSettings/index.js
// module id = 3273
// module chunks = 1137